import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class MultiSessionUsers {
  id: number;
  userId: number;
  createdAt: string;
  updatedAt: string;
}

export class CreateMultiSessionUserDTO {
  userId: number;
}

export class MultiSessionUserResponse {
  @Type(() => MultiSessionUsers)
  result: MultiSessionUsers;
}

export class MultiSessionUsersResponse extends IPagination {
  @Type(() => MultiSessionUsers)
  results: MultiSessionUsers[];
}

export class MultiSessionUserQueryParams extends IQueryPaginationDto {
  userId?: number;
}
